import React, { useState } from 'react';
import classnames from 'classnames';
import { ConfigProvider, Select, SelectProps } from 'tea-component';
// import { getSearcherFilter } from '@/pages/intelligence/components/ComposedCountrySelect/utils';
import './index.scss';
import { useDblIntl } from '../../utils/utils';
import Abnormal from '@/pages/home/components/Abnormal';

const getSearcherFilter = (isSeatchCode) => (keywords, option) => {
  try {
    const reg = new RegExp(keywords ?? '', 'gi'); // 模糊匹配正则
    const label = option?.label ?? '';
    const value = option?.text ?? '';
    // 搜索简写
    if (isSeatchCode && ((label && reg.test(label)) || (value && reg.test(value)))) {
      return true;
    }
    return !!(label && reg.test(label));
  } catch (exception) {
    console.error(exception);
  }
  return true;
};

export default function SearchSingleSelect(props: any) {
  const {
    style,
    loading,
    error,
    infoConfig,
    className,
    isShowButtonLabel = false,
    isSeatchCode = false,
    options,
    value,
    onChange,
    onSearch,
    onClose,
    selectProps = {}
  } = props;
  const {selectorName,selectorPlaceholder,searchPlaceholder} = infoConfig || {};
  const { formatMessage, isEn } = useDblIntl();

  const filter = getSearcherFilter(isSeatchCode);

  const [keyword, setKeyword] = useState('');

  const isNoData = !(options && options?.length > 0);
  const isNoSearchData = !(options && options?.filter((option) => filter(keyword, option))?.length > 0);

  const handleSearch = (keyword?: string, context?: any) => {
    const keywordTmp = keyword ?? '';
    setKeyword(keywordTmp);
    onSearch?.(keywordTmp, context);
  };

  const handleChange = (valuePayload: string, contextPayload: any) => {
    setKeyword('');
    onChange?.(valuePayload, contextPayload);
  };

  const buttonUI = (() => {
    const valueUI = (() => {
      if (!value) return '';
      if (!options?.length) return '';
      const option = options?.find((item) => item?.value === value);
      return option ? option?.text : value;
    })();

    return (
      <>
        <div className="select-button">
          <div className="select-button-text">{selectorName}123</div>
          {valueUI}
        </div>
      </>
    );
  })();

  return (
    <ConfigProvider>
      <Select
        style={style}
        className={classnames('dbl-single-select', className)}
        placeholder={selectorPlaceholder}
        appearance="button"
        listWidth={230}
        listHeight={300}
        searchable={!isNoData}
        searchPlaceholder={searchPlaceholder}
        filter={filter}
        button={isShowButtonLabel ? buttonUI : undefined}
        options={options}
        value={value}
        onChange={handleChange}
        onSearch={handleSearch}
        onClose={onClose}
        tips={
          (loading ||error || isNoSearchData) && <Abnormal
            style={{ height: '20px' }}
            isLoading={loading}
            isError={error}
            isNoData={isNoSearchData}
            nodataMsg={formatMessage({id: 'dbl_common_select_no_data'})}
          />
        }
        {...(selectProps || {})}
      />
    </ConfigProvider>
  );
};
